import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import api from "@/lib/api";
import AuthLayout from "@/components/AuthLayout";
import { Button } from "@/components/ui/button";
import { Loader2, CheckCircle2, XCircle } from "lucide-react";

export default function VerifyEmail() {
  const [params] = useSearchParams();
  const [status, setStatus] = useState("loading"); // loading | success | error

  useEffect(() => {
    const token = params.get("token");
    if (!token) {
      setStatus("error");
      return;
    }
    api.post("/auth/verify-email", { token }).then(() => setStatus("success")).catch(() => setStatus("error"));
  }, [params]);

  return (
    <AuthLayout title="Email verification" subtitle="Confirming your VoiceMatrix AI account.">
      <div className="text-center py-6" data-testid="verify-email-status">
        {status === "loading" && <Loader2 size={40} className="animate-spin text-primary mx-auto" strokeWidth={1.5} />}
        {status === "success" && (
          <>
            <CheckCircle2 size={48} className="text-primary mx-auto mb-4" strokeWidth={1.5} />
            <p className="text-secondary-foreground mb-6">Your email is verified. You can now take your free scan.</p>
            <Link to="/app"><Button className="rounded-full bg-primary text-primary-foreground font-semibold" data-testid="verify-continue-btn">Go to dashboard</Button></Link>
          </>
        )}
        {status === "error" && (
          <>
            <XCircle size={48} className="text-destructive mx-auto mb-4" strokeWidth={1.5} />
            <p className="text-muted-foreground mb-6">This verification link is invalid or has expired. Log in and request a new one.</p>
            <Link to="/login"><Button variant="outline" className="rounded-full border-border">Back to login</Button></Link>
          </>
        )}
      </div>
    </AuthLayout>
  );
}
